import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=0f661ab0&scoped=true"
import script from "./ContextMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ContextMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=0f661ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f661ab0",
  null
  
)

export default component.exports